<template>
  <div class="jukactiveApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <headComponent></headComponent>
    <div style="height:48px"></div>
    <div class="active" v-if="setActive.length > 0">
      <ul>
        <li v-for="(item,i) in setActive" @click="$router.push('jukadetail?id='+item.id)">
          <div class="images">
            <el-image style="width: 100%;border-radius:6px;height:135px" :src="baseUrl+item.image" fit="cover"></el-image>
          </div>
          <div class="txtCon">
            <div class="title">{{item.title}}</div>
            <p>
              <span v-for="(vo,k) in item.tag">{{vo.name}}</span>
            </p>
            <p>带队老师：{{item.username}}</p>
            <p>时间：{{item.start_time}} ~ {{item.end_time}}</p>
            <p>
              <font>报名{{item.useTotal}}人</font>
              <font class="last" :style="item.state == 1 ? '' : (item.state == 2 ? 'color:green' : 'color:red')">{{item.state == 1 ? '报名中' : (item.state == 2 ? '进行中' : '已结束')}}</font>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent1 :idx='0' :dx='bool'></footComponent1>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        dialogVisible:false,
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        bool:0,
        setActive:[],
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/jukactive');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.getActive();
      }
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      getActive:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getActive',
          dataType:'json',
          success:function(data){
            that.setActive = data.data
          }
        })
      },
      login:function(){
        var that = this;
        that.$httpWX.post({
          url: that.$hostApi+'home/login/login',
          method:'post',
          data:{
            code:that.code
          }
        }).then(response => {
          if(response.status == 200){
            localStorage.setItem('userjwt', response.data);
            that.getActive();
          }else{
            that.$alert(response.message, '提示');
          }
          that.fullscreenLoading = false;
        })
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  
  .jukactiveApp{
    max-width:750px;
    background:#ececec;
    margin:0 auto;
  }
  .jukactiveApp .active{
    width:96%;
    margin:0 auto;
  }
  .jukactiveApp .active h2{
    padding:10px 0 8px 0
  }
  .jukactiveApp .active h2 span{
    position:relative;
    z-index: 1;
    margin-right:12px;
    font-size:16px;
    color:#666;
    font-weight:normal
  }
  .jukactiveApp .active h2 span.curt{
    font-size:16px;
    color:#1C222B;
    font-weight:bold
  }
  .jukactiveApp .active h2 span.curt:after{
    position: absolute;
    content: '';
    width: 35px;
    height: 10px;
    border-radius: 8px;
    background-color:#6b92ff;
    top: 51%;
    right: 0px;
    z-index: -1;
  }
  .jukactiveApp .active h2 font{
    font-weight:normal;
    font-size:11px;
    color:#6b6b6b;
  }
  
  .jukactiveApp .active ul{
    width:100%;
    display:block;
  }
  .jukactiveApp .active ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .jukactiveApp .active ul li{
    background:#fff;
    padding:12px;
    margin-bottom:12px
  }
  .jukactiveApp .active ul li:last-child{
    margin-bottom:0;
  }
  .jukactiveApp .active ul li .images{
    float:left;
    width:120px;
  }

  .jukactiveApp .active ul li .txtCon{
    float:left;
    width:calc(100% - 130px);
    margin-left:10px
  }
  .jukactiveApp .active ul li .txtCon .title{
    font-size:16px;
    color:#1C222B;
    font-weight:bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .jukactiveApp .active ul li .txtCon p{
    font-size:14px;
    color:#6b6b6b;
    margin-top:10px
  }
  .jukactiveApp .active ul li .txtCon p span{
    font-size:11px;
    background: #FEF3E6;
    color: #ED7B2F;
    margin-right:8px;
    padding:4px;
    border-radius: 4px;
  }
  .jukactiveApp .active ul li .txtCon p font{
    font-size:11px;
    background: #F1F2F5;
    color: #1C222B;
    margin-right:10px;
    padding:4px;
    border-radius: 4px;
  }
  .jukactiveApp .active ul li .txtCon p font.last{
    background: #ECF2FE;
    color: #0052D9;
  }
</style>